import { CUSTOM_ELEMENTS_SCHEMA, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService, Fichier, RapportService } from '@estel-numerique/galaclick-api';
import { UtilService } from '@services/index';
import { environment } from '../../environments/environment';
import { lastValueFrom, map } from 'rxjs';
import { FileSaverService } from 'ngx-filesaver';
import { DialogGalaComponent } from '../composants/dialog-gala/dialog-gala.component';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'apropos',
    templateUrl: './apropos.component.html',
    imports: [DialogGalaComponent, MatButton],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AProposComponent {
    private util = inject(UtilService);
    private servRapport = inject(RapportService);
    private fileService = inject(FileSaverService);
    private authServ = inject(AuthService);
    public dialogRef = inject<MatDialogRef<AProposComponent>>(MatDialogRef);

    public titre = 'A propos';
    public version: {
        web: string
        ws: string
    } = { web: '', ws: '' };
    constructor() {
        this.version.web = environment.version;
        this.showModal().catch(e => this.util.fErreur(e));
    }

    public async showModal() {
        try {
            this.util.showLoader();
            await lastValueFrom(this.authServ.getCheckToken('response').pipe(map((resp) => {
                const headers = resp.headers;
                if (headers.has('version')) {
                    const bdd = headers.get('env');
                    const sBDD = (bdd === 'P') ? 'production' : ((bdd === 'Q' ? 'recette' : 'développement'));
                    this.version.ws = headers.get('version') + ' ( ' + sBDD + ' )';
                }
                return resp.body as Fichier;
            })));
        } finally {
            this.util.hideLoader();
        }
    }
    protected async telecharger() {
        try {
            this.util.showLoader();
            const fichier = await lastValueFrom(this.servRapport.getRapportLivraison());
            this.fileService.save(this.util.convertBase64toBlobExcel(fichier.contenu), fichier.nom);
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }
}
